export default __webpack_public_path__ + "static/article-how-to-live-within-your-means-e09af36f3dcdae44b1dc77c14ac83837.jpg";